import { TrackerEvent } from '../../../tracker-event';

export const events = ({ tracker, condition }) => {
  const gAds = tracker;
  const userId = condition.userId;

  const label = {
    catLabel: 'uG5-CKPJpasBEKe_sLsD',
    viewLabel: '93hPCO3T8aYBEKe_sLsD',
    signupLabel: 'mpnfCNapqKsBEKe_sLsD',
    loginLabel: 'NO4SCKzysqkBEKe_sLsD',
    applyLabel: 'A1icCNCm5aYBEKe_sLsD',
    enrollLabel: 'YzpcCPKP5aYBEKe_sLsD',
    orderLabel: 'UEkfCJjkrqsBEKe_sLsD',
    purchaseLabel: 'hvOwCITlrqsBEKe_sLsD',
  };

  return {
    [TrackerEvent.PAGE_VIEW]() {},
    [TrackerEvent.USER_SIGNUP]() {
      gAds({ label: label.signupLabel });
    },
    [TrackerEvent.USER_LOGIN]() {
      gAds({ label: label.loginLabel });
    },
    [TrackerEvent.FORMAT_VIEW]() {},
    [TrackerEvent.CATEGORY_VIEW]() {
      gAds({ label: label.catLabel });
    },
    [TrackerEvent.COURSE_VIEW]() {
      gAds({ label: label.viewLabel });
    },
    [TrackerEvent.ENROLLMENT_VIEW]() {
      gAds({ label: label.applyLabel });
    },
    [TrackerEvent.ENROLLMENT_PENDING]() {
      gAds({ label: label.enrollLabel });
    },
    [TrackerEvent.TRANSACTION_ORDER]() {
      gAds({ label: label.orderLabel });
    },
    [TrackerEvent.TRANSACTION_PAYMENT]() {
      gAds({ label: label.purchaseLabel });
    },
  };
};
